import { gql, useQuery } from '@apollo/client';

export const GET_SUBSIDIARY_COMPANIES_BY_PARENT = gql`
  query getSubsidiaryCompaniesByParent($parentCompanyId: ObjectId!) {
    getSubsidiaryCompaniesByParent(parentCompanyId: $parentCompanyId) {
      _id
      name
      businessAddress
      email
      logoFileId
      phoneNumber
      timezone
      timezoneFullFormat
      street
      city
      country
      zipCode
      ceo
      mainStreet
      mainHouseNumber
      mainZip
      mainCity
      logoUrl
      createdBy
      ownerMemberId
      subscriptionId
      datevNumberId
      datevNumber {
        _id
        datevNumber
      }
      parentCompanyId
      locations {
        _id
        name
        companyNumber
        datevNumber {
          _id
          datevNumber
        }
        businessAddresses {
          _id
          street
          city
          country
          zipCode
          holidayLocationId
          holidayLocation {
            name
          }
          departments {
            _id
            name
            costCenter
          }
        }
      }
      parentCompany {
        name
      }
    }
  }
`;

export const useGetSubsidiaryCompaniesByParent = (parentCompanyId?: string) => {
  const { data, loading } = useQuery(GET_SUBSIDIARY_COMPANIES_BY_PARENT, {
    variables: { parentCompanyId },
    skip: !parentCompanyId,
    fetchPolicy: 'network-only',
  });

  const companies = data?.getSubsidiaryCompaniesByParent || [];

  return {
    loading,
    companies,
  };
};
